module.exports = __webpack_public_path__ + "a.no1.be713931.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/a.no1.jpg
// module id = 2GWH
// module chunks = 0